/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.22.0
 */

import type { IEdmOperatorConnectionTranslation } from '@modules/internationalization/types';

import type { IAccountInfoDeliveryData } from '../types/pageAccountInfoTypes';

export const setPostTooltipTitle = (
  isCoordinator: boolean,
  isPostDisable: boolean,
  formValues: IAccountInfoDeliveryData,
  translation: IEdmOperatorConnectionTranslation,
): string => {
  return isCoordinator && isPostDisable && formValues.useEdm
    ? translation.postAndEdmNotAvailable
    : '';
};
